<fip-navbar [showLogo]="true"></fip-navbar>
<fip-vertical-nav></fip-vertical-nav>

<div class="wrapper">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</div>
